import InspirationAnalysisDetails from '@/components/InspirationAnalysisDetails';
import AccessControl from '@/components/AccessControl';
import { Stack } from '@/components/custom-components';
import { CreativeAnalysisTabs } from '@/components/custom-components/CreativeAnalysisTabs';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/shadcn/breadcrumb.tsx';
import { Button } from '@/components/shadcn/button.tsx';
import { useElementSize } from '@/hooks/useElementSize';
import { Link, createFileRoute } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { FunnelCongruenceAnalysisResponse } from './feeds.creative-toolkit.creative-analysis.index';
import { useNavigate } from '@tanstack/react-router';
import { CreativeOSPages } from '@/_shared/subscriptionPlans';

type SearchParams = {
  sideBarOpen?: boolean;
};

export const Route = createFileRoute(
  '/feeds/creative-toolkit/creative-analysis/inspiration-library/'
)({
  component: All,
  validateSearch: (search: Record<string, unknown>): SearchParams => {
    const sideBarOpen = search?.sideBarOpen as boolean;

    return {
      sideBarOpen,
    };
  },
});

function All() {
  const [squareRef] = useElementSize();

  const navigate = useNavigate();

  useEffect(() => {
    navigate({ to: '/funnel-analyzer' });
  }, []);

  return (
    <>
      <AccessControl page={CreativeOSPages.CREATIVE_TOOLKIT_COPY_GRADER}>

      <Stack ref={squareRef} className="gap-3 lg:gap-6">
        <Stack className="gap-3 lg:gap-8">
          <Stack className="gap-3 lg:gap-6">
            <Breadcrumb>
              <BreadcrumbList>
                <BreadcrumbItem>
                  <BreadcrumbLink asChild>
                    <Link to={'/feeds/creative-toolkit'}>Toolkit</Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <BreadcrumbPage>Creative Analysis</BreadcrumbPage>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>
            <div className={'flex justify-between gap-5 items-center'}>
              <div className={''}>
                <h1 className={'text-lg lg:text-2xl font-semibold'}>
                  Inspiration Library
                </h1>
                <p
                  className={
                    'text-lg lg:text-base text-thememutedforeground mt-2'
                  }
                >
                  Browse high-performing ad and landing page pairs from
                  CreativeOS Inspiration Library.
                </p>
              </div>
            </div>
            <div className="flex justify-between gap-3">
              <CreativeAnalysisTabs
                tabItems={[
                  {
                    name: 'Upload Assets',
                    link: '/feeds/creative-toolkit/creative-analysis',
                  },
                  {
                    name: 'Inspirations',
                    link: '/feeds/creative-toolkit/creative-analysis/inspiration-library',
                  },
                  {
                    name: 'My Analyses',
                    link: '/feeds/creative-toolkit/creative-analysis/my-analyses',
                  },
                ]}
              />
            </div>
          </Stack>
        </Stack>
        <div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {/* {[...Array(4)].map(() => (
              <InspirationItem data={{}} />
            ))} */}
          </div>
        </div>
      </Stack>
      </AccessControl>
    </>
  );
}

export const InspirationItem = ({
  data,
}: {
  data: FunnelCongruenceAnalysisResponse;
}) => {
  const [analysisOpen, setAnalysisOpen] = useState<boolean>(false);

  const handleAnalysisOpen = () => {
    setAnalysisOpen(!analysisOpen);
  };

  return (
    <div className="p-6 border rounded-xl space-y-[1.625rem]">
      {analysisOpen && (
        <InspirationAnalysisDetails
          data={data}
          open={analysisOpen}
          onOpenChange={handleAnalysisOpen}
        />
      )}
      <div className="flex items-center justify-between gap-4">
        <h5 className="font-semibold">E-commerce</h5>
        <div className="">
          <div className="min-w-8 h-8 font-semibold text-sm rounded-full bg-gray-50 flex justify-center items-center">
            <span>42</span>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-2">
        <div className="relative bg-gray-200 rounded-lg h-[13.625rem]">
          <div className="absolute top-2 left-2 font-medium text-xs rounded-full bg-secondary px-2 py-0.5">
            <span>Ad</span>
          </div>
          <img src={'#'} alt="" />
        </div>
        <div className="relative bg-gray-200 rounded-lg h-[13.625rem]">
          <div className="absolute top-2 left-2 font-medium text-xs rounded-full bg-secondary px-2 py-0.5">
            <span>Landing Page</span>
          </div>
          <img src={'#'} alt="" />
        </div>
      </div>
      <div className="flex justify-center">
        <Button variant={'outline'} size={'sm'} onClick={handleAnalysisOpen}>
          View Analysis
        </Button>
      </div>
    </div>
  );
};
